import { memo, useState } from 'react';
import { Space, Tooltip } from 'antd';
import { dateToString } from '@/utils';
import { useGetParentHomeStudyQuery } from '@/services/parent-api';
import { EditSvg } from '@/assets/icons';
import Panel from '@/components/panel';
import CheckItem from '@/components/check-item';
import Button from '@/components/button';
import { ProfileCol, ProfileRow } from '@/components/profile-grid';
import EditModal from './edit-modal';

const FamilyStatus = ({ parentId, permissions }) => {
  const { data, isLoading, refetch } = useGetParentHomeStudyQuery({ parentId });
  const [isEditModalOpen, openEditModal] = useState(false);

  return (
    <Panel
      // icon={<HomeSvg />}
      title="Edit Family Status"
      extra={
        (permissions.adminStaffAndSuper || permissions.writeParent) && (
          <Tooltip title="Edit Family Status">
            <Button type="link" icon={<EditSvg fontSize="16" />} onClick={() => openEditModal(true)} />
          </Tooltip>
        )
      }
      loading={isLoading}
    >
      {data && (
        <ProfileRow>
          <ProfileCol md={12} label="Status" value={data.status.name || 'None'} />
          <ProfileCol md={12} label="Agency" value={data.agency.name || 'None'} />
          <ProfileCol md={12} label="Date Completed" value={dateToString(data.completed.date) || 'None'} />
          <ProfileCol md={12} label="Type" value={data.type.name || 'None'} />
          <ProfileCol label="Notes" value={data.notes || 'None'} />
          <ProfileCol>
            <Space size="middle">
              <CheckItem value={data.homeStudyOrientation1} label="Orientation" />
              <CheckItem value={data.meetingScheduled} label="Meeting Scheduled" />
              <CheckItem value={data.homeStudyRAPT4} label="Completed RAPT IV" />
            </Space>
          </ProfileCol>
        </ProfileRow>
      )}

      <EditModal
        parentId={parentId}
        data={data}
        open={isEditModalOpen}
        refetch={refetch}
        onClose={() => openEditModal(false)}
      />
    </Panel>
  );
};

export default memo(FamilyStatus);
